/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export { CableTraySpoolTagModule } from './cable-tray-spool-tag.module';
export { CableTraySpoolTagComponent } from './cable-tray-spool-tag.component';